/* Il blocco del menu è nell'header più volte (desktop, telefono, cassetto) e
   con lui questo file: deve girare una volta sola. */
if (!window.__mbmmPronto) {
window.__mbmmPronto = true;

/* Mega menu "rail marchi + modelli": il passaggio del mouse su un marchio
   mostra i suoi modelli. Il click resta libero di seguire il link. */
(() => {
  const activate = (brand) => {
    const root = brand.closest('[data-mbmm]');
    if (!root) return;

    const index = brand.dataset.mbmmBrand;
    root.querySelectorAll('.mbmm__brand').forEach((el) => {
      el.classList.toggle('is-active', el === brand);
    });
    root.querySelectorAll('.mbmm__pane').forEach((pane) => {
      pane.classList.toggle('is-active', pane.dataset.mbmmPane === index);
    });
    root.querySelectorAll('.mbmm__promo-set').forEach((set) => {
      set.classList.toggle('is-active', set.dataset.mbmmPromo === index);
    });
  };

  document.addEventListener('pointerenter', (event) => {
    const brand = event.target.closest?.('.mbmm__brand');
    if (brand) activate(brand);
  }, true);

  document.addEventListener('focusin', (event) => {
    const brand = event.target.closest?.('.mbmm__brand');
    if (brand) activate(brand);
  });

  /* Si torna al primo marchio solo uscendo dall'intero pannello: controllando
     il solo closest() il reset scattava anche passando dal marchio ai modelli,
     e la selezione spariva a metà strada. */
  document.addEventListener('pointerleave', (event) => {
    const root = event.target;
    if (!root.matches?.('[data-mbmm]')) return;
    const first = root.querySelector('.mbmm__brand');
    if (first) activate(first);
  }, true);
})();

/* Card "In offerta ora": la pagina arriva con i segnaposto [data-mbmm-slot] e
   le card si chiedono a parte alla sezione mb-mega-vetrina, dopo il
   caricamento o al primo passaggio sul menu. La risposta resta in memoria per
   dieci minuti, così passando da una pagina all'altra il menu è già pieno.
   Da telefono il mega menu non c'è e la richiesta non parte. */
(() => {
  const KEY = 'mbmm-vetrina-v1';
  const TTL = 10 * 60 * 1000;
  let fills = null;
  let request = null;

  const slots = () => document.querySelectorAll('[data-mbmm-slot]');

  const apply = () => {
    if (!fills) return;
    slots().forEach((slot) => {
      const html = fills.get(slot.dataset.mbmmSlot);
      if (html === undefined) return;
      const range = document.createRange();
      slot.replaceWith(range.createContextualFragment(html));
    });
  };

  const parse = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const map = new Map();
    doc.querySelectorAll('template[data-mbmm-fill]').forEach((t) => {
      map.set(t.dataset.mbmmFill, t.innerHTML.trim());
    });
    return map;
  };

  const load = () => {
    if (request || !slots().length) return request;

    try {
      const saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (saved && Date.now() - saved.at < TTL) {
        fills = new Map(saved.fills);
        apply();
        return (request = Promise.resolve());
      }
    } catch (e) {}

    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    request = fetch(`${root}?section_id=mb-mega-vetrina`)
      .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
      .then((html) => {
        fills = parse(html);
        apply();
        try {
          sessionStorage.setItem(KEY, JSON.stringify({ at: Date.now(), fills: [...fills] }));
        } catch (e) {}
      })
      .catch(() => {
        request = null;
      });
    return request;
  };

  const menuVisible = () => {
    const menu = document.querySelector('header-menu');
    return !!menu && menu.offsetParent !== null;
  };

  const start = () => {
    if (!slots().length) return;
    if (menuVisible()) {
      ('requestIdleCallback' in window ? requestIdleCallback : setTimeout)(load, { timeout: 1500 });
    }
    // Chi arriva sul menu prima dell'idle non aspetta.
    document.addEventListener('pointerover', (e) => {
      if (e.target.closest?.('header-menu')) load();
    }, { passive: true });
    document.addEventListener('focusin', (e) => {
      if (e.target.closest?.('header-menu')) load();
    });
    // Se l'header viene ridisegnato (carrello, editor) i segnaposto tornano: si riempiono di nuovo.
    const header = document.querySelector('#header-group') || document.body;
    new MutationObserver(() => {
      if (fills && slots().length) apply();
    }).observe(header, { childList: true, subtree: true });
  };

  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
})();
}
